import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { destroySkin } from "../../../../actions/mine_craft/skinsActions";
import { useNavigate } from "react-router-dom";
import { selectSkinEntities, selectSkinIds, setEditId } from "../../../../store/mine_craft/skinsSlice";

import { message, Spin } from "antd";
import { LikeOutlined, MessageOutlined } from "@ant-design/icons";
import CardImage from "../../../../componets/CardImage";
import Pagination from '../../../../componets/Pagination';
import IconText from "../../../../componets/IconText";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import {formattedDate} from "../../../../helpers/DateHelpers";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const navigate  = useNavigate();
  const dispatch  = useAppDispatch();
  const ids       = useAppSelector(selectSkinIds);
  const skins     = useAppSelector(selectSkinEntities);
  const count     = useAppSelector(state => state.mineCraft.skins.count);
  const error     = useAppSelector(state => state.mineCraft.skins.error);
  const status    = useAppSelector(state => state.mineCraft.skins.status);

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroySkin(id));

    if (destroySkin.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroySkin.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const renderSkin = (id: EntityId) => {
    const skin = skins[id];

    if (!skin) {
      return;
    }
    const formattedCreatedAt = formattedDate(skin.created_at);

    return (
      <CardImage
        key={skin.id}
        image={skin.thumbnail_url}
        title={skin.title}
        link={skin.url}
        stats={[
          <IconText icon={LikeOutlined} text={skin.likes_count} />,
          <IconText icon={MessageOutlined} text={skin.comments_count} />
        ]}
        options={[
          <ButtonEdit key={`edit-${skin.id}`} onClick={() => onClickEdit(skin.id)} />,
          <ButtonDestroy key={`destroy-${skin.id}`} onClick={() => onClickDestroy(skin.id)} />
        ]}
      >
        <div className='v-small_text'>
          {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
        </div>
      </CardImage>
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      {ids && ids.map(renderSkin)}

      <Pagination total={count} size={limit} />
    </>
  );
}

export default _List;
